import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { message } from 'antd';
import { ConfirmModal } from 'components/Shared/ConfirmModal';
import { useHistory } from 'hooks/generic/useHistory';
import { useSearchParams } from 'hooks/useSearchParams';
import { customerEmailUnsubscribe } from 'appRedux/restApi';
import { getPath } from 'utils';
import passwordChangeSuccess from 'assets/images/success-tick.png';

export const UnsubscibeView = () => {
  const searchParams = useSearchParams();
  const { history } = useHistory();
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  const handleRedirect = () => {
    history.replace(getPath('/'));
  };

  useEffect(() => {
    const { email, token } = searchParams;
    if (email && token) {
      customerEmailUnsubscribe({ email, token })
        .then(data => {
          if (data.error) {
            message.error(t('account.unsubscribedError'));
            handleRedirect();
          } else {
            setVisible(true);
          }
        })
        .catch(() => {
          message.error(t('account.unsubscribedError'));
          handleRedirect();
        });
    } else {
      handleRedirect();
    }
  }, []);

  return (
    <ConfirmModal
      title={t('account.successfullyUnsubscribed')}
      visible={visible}
      onCancel={handleRedirect}
      image={passwordChangeSuccess}
      showConfirmButton={false}
    />
  );
};
